import { useState, useEffect, useCallback } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Download, Loader2, FileText } from "lucide-react";
import { toast } from "sonner";

export default function ExportDataPage() {
  const [exporting, setExporting] = useState(false);
  const [dataType, setDataType] = useState("invoices");

  const exportCSV = async () => {
    setExporting(true);
    try {
      const r = await api.get(`/${dataType}?limit=5000`);
      const items = r.data[dataType] || r.data.invoices || r.data.quotes || r.data.products || r.data.customers || r.data.suppliers || r.data.expenses || r.data.purchase_orders || [];
      if (items.length === 0) { toast.error("No data to export"); setExporting(false); return; }
      const headers = Object.keys(items[0]).filter(k => !k.endsWith("_id") || k === "product_id");
      const csv = [headers.join(","), ...items.map(row => headers.map(h => { const v = row[h]; return typeof v === "object" ? JSON.stringify(v) : `"${String(v || "").replace(/"/g, '""')}"`; }).join(","))].join("\n");
      const blob = new Blob([csv], { type: "text/csv" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a"); a.href = url; a.download = `${dataType}_export.csv`; a.click();
      toast.success(`Exported ${items.length} records`);
    } catch { toast.error("Export failed"); }
    finally { setExporting(false); }
  };

  return (
    <div data-testid="export-data-page">
      <div className="mb-6"><h1 className="font-heading font-bold text-2xl text-[#1F2937]">Export Data</h1>
        <p className="text-sm text-gray-500 mt-1">Download data as CSV</p></div>
      <Card className="border rounded-sm max-w-md"><CardContent className="p-6 space-y-4">
        <div><label className="text-xs font-semibold text-gray-500 uppercase block mb-1">Data Type</label>
          <Select value={dataType} onValueChange={setDataType}>
            <SelectTrigger data-testid="export-type"><SelectValue /></SelectTrigger>
            <SelectContent>
              {[["invoices","Invoices"],["quotes","Quotes"],["customers","Customers"],["suppliers","Suppliers"],["products","Products"],["expenses","Expenses"],["purchase-orders","Purchase Orders"]].map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}
            </SelectContent>
          </Select></div>
        <Button data-testid="export-btn" onClick={exportCSV} disabled={exporting} className="w-full bg-[#E63946] hover:bg-[#C1121F] text-white rounded-sm">
          {exporting ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Download className="w-4 h-4 mr-2" />}Export to CSV
        </Button>
      </CardContent></Card>
    </div>
  );
}
